var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20.0004H5.33333C4.59695 20.0004 4 19.4035 4 18.6671V13.3338C4 12.5974 4.59695 12.0004 5.33333 12.0004H8L12.6667 6.00044C12.9075 5.53274 13.4533 5.31042 13.9523 5.47677C14.4514 5.64312 14.7547 6.14847 14.6667 6.66711V25.3338C14.7547 25.8524 14.4514 26.3578 13.9523 26.5241C13.4533 26.6905 12.9075 26.4682 12.6667 26.0004L8 20.0004",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0401 12.6269C21.6496 12.2364 21.0164 12.2364 20.6259 12.6269C20.2354 13.0174 20.2354 13.6506 20.6259 14.0411L22.0401 12.6269ZM25.9592 19.3744C26.3498 19.7649 26.9829 19.7649 27.3734 19.3744C27.764 18.9839 27.764 18.3507 27.3734 17.9602L25.9592 19.3744ZM27.3734 14.0411C27.764 13.6506 27.764 13.0174 27.3734 12.6269C26.9829 12.2364 26.3498 12.2364 25.9592 12.6269L27.3734 14.0411ZM20.6259 17.9602C20.2354 18.3507 20.2354 18.9839 20.6259 19.3744C21.0164 19.7649 21.6496 19.7649 22.0401 19.3744L20.6259 17.9602ZM20.6259 14.0411L25.9592 19.3744L27.3734 17.9602L22.0401 12.6269L20.6259 14.0411ZM25.9592 12.6269L20.6259 17.9602L22.0401 19.3744L27.3734 14.0411L25.9592 12.6269Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOffIcon);
export default __webpack_public_path__ + "static/media/volume-off-icon.f5e041e0951ba93f27beabe6a60ee18e.svg";
export { ForwardRef as ReactComponent };